export const defaultChainId = parseInt(String(process.env.NEXT_PUBLIC_DEFAULT_CHAIN_ID))
